'use client'

import { INQUIRY_LOADS_STATUSES } from '@repo/sdk'
import {
  Badge,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Spinner,
} from '@repo/ui/components'
import { cn } from '@repo/ui/lib'

interface IOption {
  label: string
  value: string
}

const getOptions = (): IOption[] => {
  return INQUIRY_LOADS_STATUSES.map(({ alias, title }) => ({
    label: title,
    value: alias,
  }))
}

const statusOptions = getOptions()

interface Props {
  className?: string
  isPending?: boolean
  onChange: (value: string) => void
  value: string
}

export const SelectInquiryLoadStatus = ({
  className,
  isPending = false,
  onChange,
  value,
}: Props) => {
  return (
    <Select defaultValue={value} disabled={isPending} onValueChange={onChange}>
      <SelectTrigger className={cn('w-full', className)}>
        <div className={'flex items-center gap-2'}>
          <SelectValue />
          {isPending && <Spinner className={'size-4'} />}
        </div>
      </SelectTrigger>
      <SelectContent>
        {statusOptions.map(({ label, value }) => (
          <SelectItem key={value} value={value}>
            {/*@ts-ignore*/}
            <Badge variant={value}>{label}</Badge>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
